import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FamilyCodes } from 'src/app/core/_enums/family.code';
import { Energie } from 'src/app/core/_models/energie';
import { Transport } from 'src/app/core/_models/transport';

@Component({
  selector: 'app-dialog-edit-operation',
  templateUrl: './dialog-edit-operation.component.html',
  styleUrls: ['./dialog-edit-operation.component.scss']
})
export class DialogEditOperationComponent {
  FamilyCodes = FamilyCodes;

  constructor(
    public dialogRef: MatDialogRef<DialogEditOperationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.data.familyCode = this.data.transports.find((t: { resourceId: any }) => t.resourceId == this.data.produit.transportId)?.familyCode;
    this.data.produit.transportRuade = this.data.transports.find((t: { resourceId: any }) => t.resourceId == this.data.produit.transportId)?.ruade;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  selectTransportChange(value: string) {
    let t: Transport = this.data?.transports?.find((t: Transport) => t.resourceId == value);
    if (t) {
      this.data.familyCode = t?.familyCode;
      this.data.produit.transportId = t?.resourceId;
      this.data.produit.transportName = t?.displayName;
      this.data.produit.transportRuade = t?.ruade;
      if (t?.familyCode != FamilyCodes.RoadTransportCode) {
        this.data.produit.energyId = null;
        this.data.produit.energyName = null;
        this.data.produit.energieDescription = t.energieDescription;
      } else {
        this.data.produit.energieDescription = null;
        if (!this.data.produit.energyId) {
          const dieselEnergy = this.data?.energies?.find((e: Energie) => e.code === FamilyCodes.DefaultDieselEnergy) ?? this.data?.energies?.find((e: Energie) => e.code === FamilyCodes.DefaultDieselEnergyIntl);
          if (dieselEnergy) {
            this.data.produit.energyId = dieselEnergy.resourceId;
            this.data.produit.energyName = dieselEnergy.displayName;
          }
        }
      }
    } else {
      this.data.produit.transportId = null;
      this.data.produit.transportName = null;
    }
  }

  selectEnergyChange(value: string) {
    let e: Energie = this.data?.energies?.find((e: Energie) => e.resourceId == value);
    if (e && this.data.familyCode == FamilyCodes.RoadTransportCode) {
      this.data.produit.energyId = e?.resourceId;
      this.data.produit.energyName = e?.displayName;
    } else {
      this.data.produit.energyId = null;
      this.data.produit.energyName = null;
    }
  }
}
